var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ajax-progress ajax-progress-fullscreen"},[_c('div',{staticClass:"spinner-inner"},[_vm._m(0),_c('p',{staticClass:"spinner-label"},[_vm._v(_vm._s(_vm.label))])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner-throbber"},[_c('div',{staticClass:"spinner"},[_c('div',{staticClass:"bounce1"}),_c('div',{staticClass:"bounce2"}),_c('div',{staticClass:"bounce3"})])])
}]

export { render, staticRenderFns }